import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("PhoneTypeTerminal", "ExpressionTerminal", {
    type: function() {
      return 'PhoneType';
    }
  });
});
